module.exports = __webpack_public_path__ + "img/logo-part03.21b2971c.png";